import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ErrorBoundary } from "./components/ErrorBoundary";

// Public Pages
import HomePage from "./pages/public/HomePage";
import CatalogoPage from "./pages/public/CatalogoPage";
import InflableDetailPage from "./pages/public/InflableDetailPage";

// Admin Pages
import LoginPage from "./pages/admin/LoginPage";
import DashboardPage from "./pages/admin/DashboardPage";
import InflablesAdminPage from "./pages/admin/InflablesAdminPage";
import ClientesAdminPage from "./pages/admin/ClientesAdminPage";
import CotizacionesAdminPage from "./pages/admin/CotizacionesAdminPage";
import RentasAdminPage from "./pages/admin/RentasAdminPage";
import CalendarioPage from "./pages/admin/CalendarioPage";
import FinanzasAdminPage from "./pages/admin/FinanzasAdminPage";
import ReportesAdminPage from "./pages/admin/ReportesAdminPage";

// Layout
import AdminLayout from "./components/layout/AdminLayout";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-primary border-t-transparent"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }
  
  return children;
};

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/catalogo" element={<CatalogoPage />} />
            <Route path="/inflable/:id" element={<InflableDetailPage />} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<LoginPage />} />
            <Route path="/admin" element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="inflables" element={<InflablesAdminPage />} />
              <Route path="clientes" element={<ClientesAdminPage />} />
              <Route path="cotizaciones" element={<CotizacionesAdminPage />} />
              <Route path="rentas" element={<RentasAdminPage />} />
              <Route path="calendario" element={<CalendarioPage />} />
              <Route path="finanzas" element={<FinanzasAdminPage />} />
              <Route path="reportes" element={<ReportesAdminPage />} />
            </Route>
            
            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
